<ng-template #addAttendanceModal let-modal>
  <div class="modal-body" ngClass="mars-clock-wrapper" tabindex="0" ngbAutofocus>
    <ng-container *ngIf="workType === 'Hybrid' && mode !== 'remote'">
      <div class="btn-group btn-group-toggle w-100 pl-3 pr-3 mb-2" ngbRadioGroup name="radioBasic"
        [(ngModel)]="radioModel">
        <label ngbButtonLabel class="btn-outline-primary" rippleEffect>
          <input ngbButton type="radio" value="On Site" [disabled]="attendance?.signIn ? true : false" />
          On Site
        </label>
        <label ngbButtonLabel class="btn-outline-primary" rippleEffect>
          <input ngbButton type="radio" value="Remote" [disabled]="attendance?.signIn ? true : false" />
          Remote
        </label>
      </div>
    </ng-container>
    <ng-container *ngIf="mode === 'remote'">
      <h3 class="text-primary mb-2" style="font-size: 18px; font-weight: bold">
        Remote
      </h3>
    </ng-container>
    <h1 class="text-monospace">{{ time }}</h1>
    <h2>{{ date }}</h2>
  </div>
  <div class="modal-footer">
    <button *ngIf="!loading; else loadingBtn" class="btn btn-primary w-100" (click)="MarKAttendance(modal)"
      [disabled]="attendance?.signOut">
      <span *ngIf="!attendance; else signOutBtn"> Time In </span>
      <ng-template #signOutBtn>
        <span>Time Out</span>
      </ng-template>
    </button>
    <ng-template #loadingBtn>
      <button class="btn btn-primary w-100" type="button" disabled rippleEffect>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="ml-25 align-middle">Loading...</span>
      </button>
    </ng-template>
  </div>
</ng-template>
<ng-template #messageModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="messageModalTitile">Info Message</h4>
    <button type="button" class="close" (click)="closeModal(modal)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center" tabindex="0" ngbAutofocus>
    <div class="text-center my-3 px-3">
      <h4 class="text-danger">Time Tracking in progress.</h4>
      <h5 class="mb-0">
        You can not sign out until you stop your time tracking.
      </h5>
    </div>
  </div>
</ng-template>
<ng-template #dueTasksModal let-modal>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="row">
      <div class="col-12">
        <h4 class="text-center" style="font-weight: bold" *ngIf="!dueTaskLoading">
          These tasks has today's deadline please tell us why didn't you
          completed them?
        </h4>
        <!-- {{ this.values | json }} -->
        <div class="table-responsive mt-2">
          <table class="table">
            <thead>
              <tr>
                <th>Task</th>
                <th>Due Date</th>
                <th>Priority</th>
                <th></th>
              </tr>
            </thead>

            <tbody *ngFor="let task of dueTasks">
              <tr style="vertical-align: middle">
                <td style="width: 390px">
                  <span class="my-des alt" [innerText]="task.title"></span>
                </td>
                <td>{{ task.dueDate }}</td>
                <td>{{ task.priority | uppercase }}</td>
                <td class="mars-actions-td alt">
                  <span class="waves-effect btn-flat-secondary" (click)="task.expand = !task.expand">
                    <mat-icon [fontIcon]="
                        task.expand ? 'keyboard_arrow_down' : 'chevron_right'
                      "></mat-icon>
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="p-0">
                  <div [ngbCollapse]="!task.expand">
                    <quill-editor class="w-100" placeholder="Your reason here..."
                      [(ngModel)]="this.values[task.id].value">
                      <div quill-editor-toolbar>
                        <span class="ql-formats">
                          <button class="ql-bold" [title]="'Bold'"></button>
                          <button class="ql-italic" [title]="'italic'"></button>
                          <button class="ql-underline" [title]="'underline'"></button>
                        </span>
                        <span class="ql-formats">
                          <select class="ql-align" [title]="'Alignment'">
                            <option selected></option>
                            <option value="center"></option>
                            <option value="right"></option>
                            <option value="justify"></option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-list" value="ordered" type="button"></button>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-formula" value="ordered" type="button"></button>
                          <button class="ql-code-block" value="ordered" type="button"></button>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-clean" value="ordered" type="button"></button>
                        </span>
                      </div>
                    </quill-editor>
                    <span class="text-danger" *ngIf="this.values[task.id].error">Please give a reason...</span>
                    <div class="col-12 text-right px-0 py-1">
                      <button class="btn btn-primary btn-sm" (click)="submit(task.id, modal)"
                        [disabled]="this.values[task.id].loading">
                        <div class="spinner-border spinner-border-sm mr-50" role="status"
                          *ngIf="this.values[task.id].loading">
                          <span class="sr-only">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>